export const environment = {
  production: true,
  xToken: "xToken",
  uId: "uId",
  sId: "sId",
  xrefreshToken: "xrefreshToken",
  authKey:"trwmjhwiodljerok9OqeO7huL",
  appKey:"449c17ae9eef11ec8bcb1642f"
};

export const URL = {
  local: "https://www.jhacasso.com/api/admin/",
  live: "https://www.jhacasso.com/api/admin/",
  enable: "2", // 1 = local 2 = live,
  localUser: "https://www.jhacasso.com/api/",
  liveUser: "https://www.jhacasso.com/api/",
  enableUser: "2", // 1 = local 2 = live
  Jhacasso_API_URL: "https://api-dev.jhacasso.com/api/"
};

export const countryCode = [
  { name: "India", dial_code: "+91", code: "IN" },
];